export interface MarketingPreferenceChoice {
  emailOptIn: boolean;
  smsOptIn: boolean;
}

export const UNTICKED_MARKETING_PREFERENCES: MarketingPreferenceChoice = { emailOptIn: false, smsOptIn: false };
